import { useTranslation } from 'react-i18next';
import TypeCustomMultiSelect from '../../../form/form-fields/TypeCustomMultiSelect';
import { FormFieldsHighlightContainer } from '../../../form/FormFieldsHighlightContainer';

export const MatchingPropLeadFieldSelect = ({
  property,
  onChange,
  required,
  size = 'small',
}) => {
  const { t } = useTranslation();

  const valueField = {
    label: property.label,
    key: 'minValue',
    options: property.options || [],
    noUnselect: true,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <FormFieldsHighlightContainer
      error={!property.minValue?.length}
      field={valueField}
      hasValidation={true}
      hidden={required !== true}
    >
      <TypeCustomMultiSelect
        size={size}
        field={valueField}
        dataCollection={property}
        startDataCollection={property}
        updateValidationOnChange={handleUpdate}
      />
    </FormFieldsHighlightContainer>
  );
};
